import axios from 'axios';

import { toCamelCaseRecursive } from '../helpers/string';
import { fetchAuthToken } from './tokens';
import { API_URL, DOCHUB_API_URL } from '../config';

const headers = {
  'Content-Type': 'application/json',
};

const instance = axios.create({
  baseURL: API_URL,
  headers,
});

const dochubInstance = axios.create({
  baseURL: DOCHUB_API_URL,
});

instance.interceptors.request.use((config) => {
  const token = fetchAuthToken();

  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = token ? `Bearer ${token}` : null;

  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (response?.data?.code === 400) {
      return Promise.reject(response.data);
    }

    if (response?.data?.errors && !response?.data?.ok) {
      return Promise.reject({ message: response.data.errors });
    }

    return Promise.resolve(toCamelCaseRecursive(response.data));
  },
  (error) => Promise.reject(error),
);

dochubInstance.interceptors.response.use(
  (response) => Promise.resolve(toCamelCaseRecursive(response.data)),
  (error) => Promise.reject(error),
);

export { dochubInstance };

export default instance;
